import { BooleanColumn, CategoricalColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	placeholderFor: 'placeholderFor',
	widgetType: 'widgetType',
	numOfCols: 'numOfCols',
	isSpaceWidgetRequiredBelow: 'isSpaceWidgetRequiredBelow'
};

export const layoutConfig = [
	CategoricalColumn({
		title: 'Items Placeholder',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.placeholderFor]
	}),
	CategoricalColumn({
		title: 'Widget Type',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.widgetType] || EMPTY_STRING
	}),
	CategoricalColumn({
		title: 'Width Occupied',
		width: 180,
		mapDataToValue: (data: any) => (data[COL_NAMES.numOfCols] ? `${100 / +data[COL_NAMES.numOfCols]}%` : EMPTY_STRING)
	}),
	BooleanColumn({
		title: 'Add Space Below this Widget?',
		width: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.isSpaceWidgetRequiredBelow] || false
	})
];
